var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page__button_to-prev-page",class:_vm.rootCss,on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fa fa-long-arrow-left",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v("Вернуться обратно")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da9008a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/_shared/components/ui/PreviousPageButton.vue
// module id = null
// module chunks = 